import { type Common } from './common.js';
import { type CreateValues } from './models/careGapFindings.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async createBulk(
    values: CreateValues[]
  ): Promise<{ status: number; message?: string | undefined }> {
    const url = this.common.constructPath('/care-gap-findings/create');
    return await this.common.postJSON(url, { careGapFindings: values });
  }

  async findAllByPatientDocumentId(
    patientDocumentId: string
  ): Promise<{ careGapFindings: CreateValues[] }> {
    const url = this.common.constructPath('/care-gap-findings/find', {
      patientDocumentId,
    });
    return await this.common.getJSON(url);
  }
}
